import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { LoanDashboardStore } from '../stores/loanDashboardStore';

export const useLoanDashboardStore = () =>
  useContext<{
    loanDashboardStore: LoanDashboardStore;
  }>(StoreContext);